import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ZW_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#ZW_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ZW_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#ZW_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 2v20h32V2H0z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M0 8.25h-1.75v7.5h35.5v-7.5H0z",
      fill: "#272727",
      stroke: "#E31D1C",
      strokeWidth: 3.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 4V0h32v4H0zm0 20v-4h32v4H0z",
      fill: "#5EAA22"
    }
  )), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M.597-.802L-1-1.991V25.96l1.587-1.15L16.918 12.96l1.102-.799-1.092-.812L.597-.802z",
      fill: "#F7FCFF",
      stroke: "#272727",
      strokeWidth: 2
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "ZW_svg__c",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: -2,
      y: -4,
      width: 22,
      height: 32
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        d: "M.597-.802L-1-1.991V25.96l1.587-1.15L16.918 12.96l1.102-.799-1.092-.812L.597-.802z",
        fill: "#fff",
        stroke: "#fff",
        strokeWidth: 2
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#ZW_svg__c)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.48 14.278l-3.78 3.05 1.734-4.076-2.979-2.868h3.516l1.442-3.46 1.532 3.46h3.51L9.32 13.252l1.57 4.076-3.41-3.05z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.018 8.421s-.055-.132.269-.249c.324-.117.422-.365.676-.182.254.182.413-.185.486.341.072.526.273 1.355.273 1.355l3.288 2.471h-.618S8.43 13.57 8.59 14.81c0 0-.664-.1-1.563-.1-.9 0-1.489.215-1.489.215L5.017 13s.189-.323.27-.583c.08-.261.415-.309.415-.516 0-.207-.33-.381-.165-.917.165-.537.165-2.141.165-2.141s-.522-.23-.415-.23c.106 0 .348-.193.174-.193h-.443z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6.722 9.686l-.121.03.01.043.036.027 2.988 2.246h-.309l-.037.055.103.07-.103-.07h0l-.001.001-.003.004-.008.012a4.302 4.302 0 00-.141.23c-.09.156-.207.375-.32.635-.205.473-.4 1.093-.366 1.697a12.662 12.662 0 00-1.424-.082c-.46 0-.84.055-1.107.11a4.171 4.171 0 00-.295.073l-.472-1.749.006-.011c.02-.036.046-.085.075-.144.059-.115.13-.268.173-.408.027-.086.095-.14.194-.215l.003-.003c.044-.033.098-.073.14-.122a.32.32 0 00.084-.213.46.46 0 00-.063-.214 2.708 2.708 0 00-.036-.064c-.02-.035-.038-.068-.056-.11-.05-.11-.088-.257-.015-.493.045-.146.077-.358.1-.584.024-.23.04-.483.05-.718a22.487 22.487 0 00.02-.804v-.07h0v-.001 0h-.125.125v-.082l-.074-.033h0-.002l-.004-.002-.016-.007-.057-.026a7.232 7.232 0 01-.135-.063.49.49 0 00.075-.08.181.181 0 00.033-.1.149.149 0 00-.08-.132.224.224 0 00-.106-.023H5.449h0-.002 0-.002 0-.002 0H5.43h0-.002 0-.002 0H5.417h0-.002 0H5.406h0-.002 0-.008 0H5.387h0-.008 0-.008 0-.002 0-.006 0-.008 0-.007 0-.008 0-.007 0-.007 0-.007 0-.007 0-.002l.018-.006c.093-.034.168-.076.23-.115l.072-.047c.03-.02.054-.035.08-.05.04-.022.065-.028.083-.028.018 0 .047.006.096.041.148.107.303.08.365.069l.022-.003c.012.02.031.071.048.191.037.268.106.611.166.885a24.971 24.971 0 00.1.446l.007.027.002.007v.002h0l.122-.029z",
      stroke: "#0A0A0A",
      strokeWidth: 0.25
    }
  )))
), a = t;
export {
  a as default
};
